import React from "react";
// import { ReactComponent as ShareBtn } from "../assets/icons/share_bt.svg";
// import { ReactComponent as Camera } from "../assets/icons/camera.svg";
import { toBase64, resizeBase64Img } from "./Dependencies";
import { Camera, Notepad } from "iconsax-react";
export default function FileSelector({ fileId, files, image, multiple }) {
    const getFileHandle = async (e) => {
        // push files to relative file array;

        let files64 = [];
        for (let file of [...e.target.files]) {
            console.log(file);
            if (multiple) {
                let base64 = await toBase64(file);
                if (file.type.split("/")[0] === "image") {
                    base64 = await resizeBase64Img(base64, 1200);
                }
                files64.push(base64);
            } else {
                let base64 = await toBase64(file);
                if (file.type.split("/")[0] === "image") {
                    base64 = await resizeBase64Img(base64, 1200);
                }
                files64 = base64;
            }
        }
        console.log(files64);
        return files64;
    };

    return (
        <div className="file-btn">
            <label
                htmlFor={"file-upload" + fileId}
                className="custom-file-upload"
            >
                {image ? <Camera /> : <Notepad />}
            </label>
            <input
                id={"file-upload" + fileId}
                type="file"
                accept={image ? "image/*" : "*"}
                onChange={(e) => getFileHandle(e).then((e) => files(e))}
                multiple={multiple}
            />
        </div>
    );
}
